export const lastTabState = {
    actions: {
        setContentLastTab: (tab, state) => ({...state, contentLastTab: tab}),
        setNetworkLastTab: (tab, state) => ({...state, networkLastTab: tab}),
        setLastRankingsTab: (tab, state) => ({...state, lastRankingsTab: tab}),
        setLastRankingsFilter: (filter, state) => ({...state, lastRankingsFilter: filter}),
        setProfileLastTab: (tab, state) => ({...state, profileLastTab: tab}),
        setProfileLastSection: (section, state) => ({...state, profileLastSection: section}),
    },
}
